import { MutationFn, FetchResult } from 'react-apollo';
import {
  core_apimessages_AdyenPaymentResult_PaymentStatus as PaymentStatus,
  core_apimessages_GuestCheckoutChallengeShopperRequest as GuestCheckoutChallengeShopperRequest,
  core_apimessages_GuestCheckoutIdentifyShopperRequest as GuestCheckoutIdentifyShopperRequest,
  Input_core_apimessages_CheckoutChallengeShopperRequest as CheckoutChallengeShopperRequest,
  Input_core_apimessages_CheckoutIdentifyShopperRequest as CheckoutIdentifyShopperRequest,
  SubmitCheckoutChallengeShopper,
  SubmitCheckoutIdentifyShopper,
  SubmitGuestCheckoutChallengeShopper,
  SubmitGuestCheckoutIdentifyShopper,
} from '../../schemas/rql';
import { parseGraphqlErrors } from '@reverbdotcom/commons/dist/parse_graphql_errors';
import { PaymentStatusCallbacks } from './payment_status_callbacks';


export async function submitCheckoutIdentifyShopper(
  input: CheckoutIdentifyShopperRequest,
  mutation: MutationFn<SubmitCheckoutIdentifyShopper.Mutation>,
  callbacks: PaymentStatusCallbacks,
) {
  try {
    const result = await mutation({ variables: { input } }) as FetchResult<SubmitCheckoutIdentifyShopper.Mutation>;
    const { paymentStatus, challengeToken } = result.data.checkoutIdentifyShopper.adyenPaymentResult;
    const { paymentResultUrl } = result.data.checkoutIdentifyShopper;
    if (paymentStatus === PaymentStatus.CHALLENGE_SHOPPER_REQUIRED) {
      callbacks.onChallengeShopperRequired(challengeToken);
    } else if (paymentStatus === PaymentStatus.SUCCESS) {
      callbacks.onSuccess(paymentResultUrl);
    }
  } catch (error) {
    callbacks.onError(parseGraphqlErrors(error));
  }
}

export async function submitCheckoutChallengeShopper(
  input: CheckoutChallengeShopperRequest,
  mutation: MutationFn<SubmitCheckoutChallengeShopper.Mutation>,
  callbacks: PaymentStatusCallbacks,
) {
  try {
    const result = await mutation({ variables: { input } }) as FetchResult<SubmitCheckoutChallengeShopper.Mutation>;
    const { paymentStatus } = result.data.checkoutChallengeShopper.adyenPaymentResult;
    const { paymentResultUrl } = result.data.checkoutChallengeShopper;
    if (paymentStatus === PaymentStatus.SUCCESS) {
      callbacks.onSuccess(paymentResultUrl);
    }
  } catch (error) {
    callbacks.onError(parseGraphqlErrors(error));
  }
}

export async function submitGuestCheckoutIdentifyShopper(
  input: GuestCheckoutIdentifyShopperRequest,
  mutation: MutationFn<SubmitGuestCheckoutIdentifyShopper.Mutation>,
  callbacks: PaymentStatusCallbacks,
) {
  try {
    const result = await mutation({ variables: { input } }) as FetchResult<SubmitGuestCheckoutIdentifyShopper.Mutation>;
    const { paymentStatus, challengeToken } = result.data.guestCheckoutIdentifyShopper.adyenPaymentResult;
    const { paymentResultUrl } = result.data.guestCheckoutIdentifyShopper;
    if (paymentStatus === PaymentStatus.CHALLENGE_SHOPPER_REQUIRED) {
      callbacks.onChallengeShopperRequired(challengeToken);
    } else if (paymentStatus === PaymentStatus.SUCCESS) {
      callbacks.onSuccess(paymentResultUrl);
    }
  } catch (error) {
    callbacks.onError(parseGraphqlErrors(error));
  }
}

export async function submitGuestCheckoutChallengeShopper(
  input: GuestCheckoutChallengeShopperRequest,
  mutation: MutationFn<SubmitGuestCheckoutChallengeShopper.Mutation>,
  callbacks: PaymentStatusCallbacks,
) {
  try {
    const result = await mutation({ variables: { input } }) as FetchResult<SubmitGuestCheckoutChallengeShopper.Mutation>;
    const { adyenPaymentResult, paymentResultUrl } = result.data.guestCheckoutChallengeShopper;
    if (adyenPaymentResult.paymentStatus === PaymentStatus.SUCCESS) {
      callbacks.onSuccess(paymentResultUrl);
    }
  } catch (error) {
    callbacks.onError(parseGraphqlErrors(error));
  }
}



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/src/credit_cards/threeds2/threeds2_checkout_submission.ts